import SecondarySmall from "./SecondarySmall";

export default SecondarySmall;
export { SecondarySmall as H6 };
